<template lang="pug">
cm-sidebar(
  :isMultipleMode="false"
  :isCurssusPage="true"
  :loading="loading"
  :courseList="courseList"
  :selector="selector"
  @needToUpdateData="loadData"
  @click:select="selectDate"
)

</template>

<script>
import Selector from '@/util/selector'
import CMDateHashMap, { CMDateHashMapSelectableDecorator } from "../../classes/CMDateHashMap"
import ModalBody from '../cm_course/CMCourseBody.vue'
import { PerPageStorage } from '../../../../../../models/perPageStorage'
import uniq from '@/util/uniqInArray.js'
import { getMultipleQueryValueWithNumber } from '@/util'
import { createNamespacedHelpers } from 'vuex'
import { VIOLET_COLOR } from '../../core/cm-const'

const { mapState, mapMutations, mapGetters, mapActions } = createNamespacedHelpers('cm')

import { CANDIDATE_PAGE } from '../../../candidates/core/candidates-const'
import cmSidebar from "../CMСurssSidebar.vue"
import cmSidebarMixin from "../../core/mixins/cmSidebar.mixin"

export default {
  inject: ['svc'],
  name: 'CmCurssusenSelectorSidebar',
  mixins: [cmSidebarMixin],
  
  data: () => ({
  }),

  computed: {
  },

  async mounted() {
    this.$emit('mounted')
    this.initStorage();
    await this.loadData()
    this.setSingleMode()
  },

  methods: {
    ...mapMutations({
      setSingleMode: 'setSingleMode',
      showingSlotsForCurssusenPage: 'showingSlotsForCurssusenPage'
    }),
    ...mapActions({
      courseListDetailed: 'courseListDetailed'
    }),
    initStorage() {
      this.storage = new PerPageStorage()
    },
    async loadData() {
      await this.loadList()
    },


    async loadList() {
      try {
        this.loading = true
        const query = {...this.$route.query, is_provided: true}
        delete query.size;
        await this.courseListDetailed({ query })
        this.showingSlotsForCurssusenPage()
        this.$emit('coursesLoaded', this.list)
      } catch (error) {
        console.log(error)
      }
      finally {
        this.loading = false
      }
    },

    async selectDate(item) {
      if(item.active){
        this.unSelectCourse(item)
      } else {
        this.setCourses([item])
      }
      await this.setDateQuery()
      this.informAboutChangedDate()
    },
  },

  components: {
    cmSidebar: cmSidebar,
    createCourseProvider: () => import('../cm_course/CMCreateCourseProvider.vue'),
    modalBody: ModalBody,
    courseValidator: () => import('../cm_course/CMCourseValidator.vue'),
    examDataStore: () => import('../cm_exam/CMExamDataStore.vue'),
    examBody: () => import('../cm_exam/CmExamBody.vue'),
    configCreateProvider: () => import('../cm_exam/CMExamAddProvider.vue'),
    showingProvider: () => import('@/components/renderless/ShowingProvider.vue'),
    createCourseExam: () => import('../cm_course/CMCreateCourseExam.vue'),
    formErrorsProvider: () => import('@/components/renderless/FormErrors.vue'),
    courseExamValidator: () => import('../cm_course/CMCourseExamValidator.vue'),
  }
}
</script>

<style lang="scss" scoped>

.cm-sidebar {
  width: 170px;
  min-width: 170px;
  height: calc(100vh - 135px);
  border-right: 1px solid $border-color;
  position: relative;
  padding-top: 64px;
  @media screen and (max-width: 767px) {
    width: 0;
    min-width: 0;
    background-color: #fff;
    z-index: 4;
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: 5px 0 14px -3px rgba(0,0,0,0.5);
    &--expanded {
      width: 170px!important;
      min-width: 170px!important;
    }
  }
  &__wrapper {
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }
  &__preloader {
    margin-top: 5px;
    padding-left: 24px;
    padding-right: 24px;
    &-item {
      padding: 8px 0;
    }
  }
  &__header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  &__title {
    @extend %title-subsection;
  }
  &__expand {
    position: absolute;
    top: 0;
    right: -32px;
    background-color: $primary-color;
    color: #fff;
    display: none;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.5);;
    @media screen and (max-width: 767px) {
      display: flex;
    }
  }
}

  .mode-switch{
    position: absolute;
    top: 10px;
  }

  .mb-30{
    margin-bottom: 30px;
  }

  ::v-deep .v-input--selection-controls.v-input .v-label{
    font-size: 12px;
  }

.course-date {
  word-break: break-all;
}
</style>
